import React from "react";
import { Shield, Wallet, Globe2, Clock, ThumbsUp } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import Reveal from "./Reveal";

const ICONS = [Shield, Wallet, Globe2, Clock, ThumbsUp];

export const KenapaKami = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="why-section"
      className="bg-[#0C2230] py-24 text-[#FBFAF6] md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <Reveal>
          <div className="max-w-2xl">
            <span className="flex items-center gap-3 text-[11px] uppercase tracking-[0.28em] text-[#B7892F]">
              <span className="h-px w-8 bg-[#B7892F]" />
              {t.why.eyebrow}
            </span>
            <h2 className="mt-5 font-[Fraunces] text-4xl font-medium leading-[1.05] tracking-tight text-white sm:text-5xl">
              {t.why.title}
            </h2>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-5">
          {t.why.items.map((item, idx) => {
            const Icon = ICONS[idx % ICONS.length];
            return (
              <Reveal key={item.title} delay={idx * 0.06}>
                <div
                  data-testid={`why-card-${idx}`}
                  className="flex flex-col gap-4 border-t border-white/15 pt-6"
                >
                  <Icon className="h-6 w-6 text-[#0E9A57]" strokeWidth={1.6} />
                  <h3 className="font-[Fraunces] text-xl font-medium text-white">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-white/65">
                    {item.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default KenapaKami;
